import { BookOpen } from "lucide-react";
import { Reveal } from "@/components/campaign/Reveal";

const OUTLINE = [
  "A symptom timeline worksheet",
  "Which past lab results and medication/supplement lists to bring",
  "10 questions to ask your doctor",
  "A sleep / energy / digestion 7-day log",
  "What to expect in a 60-minute visit, including pricing",
  "An HSA/FSA phone script",
];

export const PrepKitSection = ({ onOpen }) => (
  <section data-testid="fm-prepkit-section" className="py-16 sm:py-24 bg-[var(--brand-navy)] text-white">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 grid lg:grid-cols-[1fr_1.4fr] gap-10 lg:gap-14 items-center">
      <Reveal>
        <div className="guide-book w-44 sm:w-52 mx-auto lg:mx-0">
          <div className="guide-book-inner">
            <img
              src="/images/fm/prep-kit-cover.webp"
              alt="Cover of the All-In Functional Medicine Visit Prep Kit"
            />
          </div>
        </div>
      </Reveal>
      <div>
        <Reveal>
          <p className="flex items-center gap-2 text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-[var(--brand-gold)]">
            <BookOpen className="h-4 w-4" aria-hidden="true" /> Free download
          </p>
          <h2 className="mt-3 font-serif-brand text-3xl sm:text-4xl font-medium leading-tight">
            Free: Your First Functional Medicine Visit Prep Kit
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-white/85">
            Walk into your first visit prepared, so every one of your 60 minutes is spent on you.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <ul className="mt-6 grid sm:grid-cols-2 gap-x-8 gap-y-3">
            {OUTLINE.map((item, i) => (
              <li key={item} className="flex items-start gap-3 text-[15px] leading-relaxed text-white/90">
                <span className="mt-0.5 font-serif-brand text-lg font-semibold text-[var(--brand-gold)]" aria-hidden="true">
                  {i + 1}.
                </span>
                {item}
              </li>
            ))}
          </ul>
          <button
            data-testid="fm-prepkit-open-button"
            onClick={onOpen}
            className="mt-8 inline-flex items-center justify-center bg-[var(--brand-gold)] text-[var(--brand-navy-deep)] text-lg font-semibold px-10 py-4 hover:brightness-110 transition-[filter]"
          >
            Send Me the Prep Kit
          </button>
          <p className="mt-3 text-sm text-white/60">
            Instant download, plus an emailed copy. No spam, ever.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
